export const Cache = {
    loadCount: 0,
    caching: {},
    loaded: {},
    loadedArray: [],
    queue: [],
    videos: {},
    videosLoading: {},
    memory: {
        images: 0,
        videos: 0,
        kb: 0,
    },

    add(src) {
        if (!this.caching[src]) {
            this.caching[src] = true;
            const img = new Image();
            img.onload = () => {
                this.loaded[src] = img;
                this.loadedArray.unshift(src);
                // // Remove images, if more than 100 images stored in cache
                // if (this.loadedArray.length > 30) {
                //     console.log(this.loadedArray[this.loadedArray.length - 1])
                //     delete this.loaded[this.loadedArray[this.loadedArray.length - 1]];
                //     delete this.caching[this.loadedArray[this.loadedArray.length - 1]];
                //     this.loadedArray.pop();
                // }
                this.loadCount++;
                this.memory.images++;
                this.memory.kb += img.filesize;
                // console.log(this.memory, this.loadedArray.length);
            };
            img.src = src;
        }
    },

    addVideo(src) {
        if (!this.videosLoading[src]) {
            const video = document.createElement("video");
            video.muted = true;
            video.autoplay = true;
            video.loop = true;
            video.src = src;
            video.onVideoCanPlay = () => {
                this.videos[src] = video;
                video.play();
                this.memory.videos++;
                video.removeEventListener("canplay", video.onVideoCanPlay, true);
                this.videosLoading[src] = null;
            };
            video.addEventListener("canplay", video.onVideoCanPlay, true);
            this.videosLoading[src] = video;
        }
    },
};
